import { QUESTIONS_GPLX_CODE } from "~/api/questionsGPLXCode";
import { QUESTIONS_TEST } from "~/api/questionsTest";

export const getGPLXCode = () => {
    const gplxCode = localStorage.getItem('gplxCode')
    // console.log('gplxCode', gplxCode)
    if (!gplxCode) {
        localStorage.setItem('gplxCode', "B");
        return "B"
    }
    return gplxCode;
};

export const getTimeForTest = () => {
    const gplxCode = getGPLXCode();
    return QUESTIONS_TEST.filter(item => item.code === gplxCode)[0].time
};

export const getConfigForTest = (gplxCode) => {
    return QUESTIONS_TEST.filter(item => item.code === gplxCode)[0]
};

export const getLesson = (gplxCode, id) => {
    return QUESTIONS_GPLX_CODE.filter(item => item.codes.includes(gplxCode) && item.id === id)[0];
};

export const checkIsImportant = (gplxCode, no) => {
    return QUESTIONS_GPLX_CODE.filter(item => item.codes.includes(gplxCode) && item.id === "important")[0].questions.includes(no);
};